module.exports = __webpack_public_path__ + "static/media/allDishes.c26cd7da.png";